import React from 'react';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import { FilterPopover, ListPagination, ListPlaceholder, ListSearch } from '../components/lists/ListPageParts';
import { countActiveFilters } from '../utils/listFilters';
import EventCard from '../features/events/components/EventCard';
import EventFilterFields from '../features/events/components/EventFilterFields';
import { NO_EVENT_FILTERS, useEventList } from '../features/events/hooks/useEventList';
import '../features/events/styles/events.css';

export default function EventsPage() {
  const {
    listAreaRef, items: events, loading, error, pagination,
    query, setQuery, filters, setFilter, setFilters, sort, setSort, statusOptions,
  } = useEventList();
  const { total } = pagination;

  return (
    <div className="events-page">
      <div className="events-content">
        <div className="events-page-head">
          <div>
            <h1>Events</h1>
            <p>{total} {total === 1 ? 'event' : 'events'}</p>
          </div>
        </div>

        <div className="events-toolbar">
          <ListSearch prefix="events" placeholder="Search events..." value={query} onChange={setQuery} />

          <div className="events-toolbar-spacer" />

          <FilterPopover
            prefix="events"
            activeCount={countActiveFilters(filters)}
            resetLabel="Reset"
            onReset={() => setFilters(NO_EVENT_FILTERS)}
          >
            <EventFilterFields filters={filters} setFilter={setFilter} statusOptions={statusOptions} />
          </FilterPopover>

          <select className="events-input" value={sort} onChange={(event) => setSort(event.target.value)}>
            <option value="newest">Newest</option>
            <option value="oldest">Oldest</option>
            <option value="az">A to Z</option>
            <option value="sessions">Most sessions</option>
          </select>
        </div>

        <div className="events-list-area" ref={listAreaRef}>
          {loading ? (
            <ListPlaceholder prefix="events" isLoading title="Loading events..." detail="Fetching event list from the backend." />
          ) : error ? (
            <ListPlaceholder prefix="events" isError Icon={CalendarDaysIcon} title="Events unavailable" detail={error} />
          ) : events.length === 0 ? (
            <ListPlaceholder prefix="events" Icon={CalendarDaysIcon} title="No events match." detail="Clear search or try a different status." />
          ) : (
            <div className="events-grid">
              {events.map((event) => <EventCard key={event.id} event={event} />)}
            </div>
          )}
        </div>

        <div className="events-pagination-slot">
          {!loading && !error && events.length > 0 && <ListPagination prefix="events" {...pagination} />}
        </div>
      </div>
    </div>
  );
}
